import 'css-chunk:src/applications/ProductFulfillmentApp/NoCatalogueProductSelection/components/ProductOrderForm/ProductOrderForm.scss';export default {
  "ProductOrderForm": "_ProductOrderForm_sdcmy_1",
  "content": "_content_sdcmy_17",
  "instruction": "_instruction_sdcmy_32",
  "form": "_form_sdcmy_33",
  "mandatoryFields": "_mandatoryFields_sdcmy_43",
  "quantity": "_quantity_sdcmy_50",
  "productName": "_productName_sdcmy_54"
};